import { X, User, Lock, Bell, LogOut, BarChart2, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthPage/AuthContext";

export default function SettingsDrawer({ open, onClose }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();          // clears token state + localStorage + blacklists refresh
      navigate("/auth");
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/auth");
    }
  };

  const menuItems = [
    { icon: <User className="w-5 h-5" />, label: "Profile Settings", onClick: () => {} },
    { icon: <Lock className="w-5 h-5" />, label: "Privacy & Security", onClick: () => {} },
    { icon: <Bell className="w-5 h-5" />, label: "Notifications", onClick: () => navigate('/notifications') },
    { icon: <BarChart2 className="w-5 h-5" />, label: "Earnings", onClick: () => navigate("/CreaterDashboard") },
  ];

  return (
    <>
      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      <div className={`fixed top-0 right-0 h-full w-full sm:w-96 bg-[#111]
        border-l border-white/10 z-50 transform transition-transform duration-300
        ${open ? "translate-x-0" : "translate-x-full"}`}>

        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4
          border-b border-white/10">
          <h2 className="text-white font-semibold text-base">Settings</h2>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full hover:bg-white/10 transition"
          >
            <X className="w-5 h-5 text-white/60" />
          </button>
        </div>

        {/* Menu Items */}
        <div className="py-2">
          {menuItems.map((item, i) => (
            <button
              key={i}
              onClick={() => { item.onClick(); onClose(); }}
              className="flex items-center justify-between w-full px-5 py-4
                text-white/70 hover:text-white hover:bg-white/5 transition"
            >
              <div className="flex items-center gap-3">
                <span className="text-white/40">{item.icon}</span>
                <span className="text-sm font-medium">{item.label}</span>
              </div>
              <ChevronRight className="w-4 h-4 text-white/20" />
            </button>
          ))}
        </div>

        {/* Logout — bottom */}
        <div className="absolute bottom-8 left-0 right-0 px-5">
          <button
            onClick={handleLogout}
            className="flex items-center justify-center gap-2 w-full py-3
              rounded-xl bg-red-500/10 border border-red-500/20
              text-red-400 hover:bg-red-500/20 transition text-sm font-medium"
          >
            <LogOut className="w-4 h-4" />
            Logout
          </button>
        </div>

      </div>
    </>
  );
}